import { render, staticRenderFns } from "./ResearchSectionFiltersVertical.vue?vue&type=template&id=1853e04f"
import script from "./ResearchSectionFiltersVertical.vue?vue&type=script&lang=js"
export * from "./ResearchSectionFiltersVertical.vue?vue&type=script&lang=js"
import style0 from "./ResearchSectionFiltersVertical.vue?vue&type=style&index=0&id=1853e04f&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1853e04f')) {
      api.createRecord('1853e04f', component.options)
    } else {
      api.reload('1853e04f', component.options)
    }
    module.hot.accept("./ResearchSectionFiltersVertical.vue?vue&type=template&id=1853e04f", function () {
      api.rerender('1853e04f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchSectionFiltersVertical.vue"
export default component.exports